import { type FormEvent, useState } from 'react';
import { signInWithEmail } from '@/lib/authClient';
import { AuthCard, authButtonClass, authInputClass } from './AuthCard';

/** Email/password sign-in. On success, the session hook in `AuthGate` re-renders
 *  to the app. Registration is invite-only, so there's no sign-up link. */
export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    const result = await signInWithEmail(email, password);
    setSubmitting(false);
    // Don't leak which field was wrong.
    if (result.error) setError('Invalid email or password.');
  };

  return (
    <AuthCard>
      <form onSubmit={onSubmit} className="flex flex-col gap-4">
        <label className="flex flex-col gap-1 text-sm font-medium text-content-text">
          Email
          <input
            type="email"
            autoComplete="email"
            required={true}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className={authInputClass}
          />
        </label>

        <label className="flex flex-col gap-1 text-sm font-medium text-content-text">
          Password
          <input
            type="password"
            autoComplete="current-password"
            required={true}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className={authInputClass}
          />
        </label>

        {error ? <p className="text-sm text-error-main">{error}</p> : null}

        <button type="submit" disabled={submitting} className={authButtonClass}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>

      <div className="mt-6 text-xs text-content-subtle">
        <a href="/forgot-password" className="hover:text-secondary-emphasized">
          Forgot password?
        </a>
      </div>
    </AuthCard>
  );
};
